// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post-manage {

    width: 100%;
}





/* =========================
   검색
========================= */

.post-search-wrap {

    margin-bottom: 20px;
}





.post-search-input {

    width: 320px;

    height: 44px;

    padding: 0 18px;

    border-radius: 14px;

    border: 1px solid rgba(255,255,255,0.08);

    background:
            rgba(255,255,255,0.04);

    color: white;

    font-size: 14px;

    outline: none;
}





.post-search-input::placeholder {

    color:
            rgba(255,255,255,0.35);
}





/* =========================
   테이블
========================= */

.post-table {

    display: flex;

    flex-direction: column;

    gap: 14px;
}





/* =========================
   헤더
========================= */

.post-table-header {

    display: grid;

    grid-template-columns:
            80px
            1fr
            110px
            250px;

    align-items: center;

    padding: 18px 22px;

    border-radius: 22px;

    background:

            linear-gradient(

                    135deg,

                    rgba(255,255,255,0.05),

                    rgba(255,255,255,0.02)
            );

    border:

            1px solid
            rgba(255,255,255,0.06);

    color:

            rgba(255,255,255,0.7);

    font-size: 14px;

    font-weight: 700;
}





/* =========================
   카드
========================= */

.post-table-row {

    display: grid;

    grid-template-columns:
            80px
            1fr
            110px
            250px;

    align-items: center;

    gap: 12px;

    min-height: 120px;

    padding: 24px;

    border-radius: 26px;

    background:

            linear-gradient(

                    135deg,

                    rgba(255,255,255,0.05),

                    rgba(0,153,255,0.06)
            );

    border:

            1px solid
            rgba(255,255,255,0.05);

    transition: 0.25s;
}





.post-table-row:hover {

    transform: translateY(-2px);

    border-color:

            rgba(122,92,255,0.35);
}





/* =========================
   번호
========================= */

.post-table-row > div:first-child {

    font-size: 28px;

    font-weight: 800;

    color: white;
}





/* =========================
   내용
========================= */

.post-content-cell {

    width: 100%;

    color: white;

    font-size: 18px;

    font-weight: 600;

    line-height: 1.8;

    word-break: break-word;

    padding-right: 20px;
}





/* =========================
   댓글 카운트
========================= */

.post-comment-count {

    width: 70px;

    height: 42px;

    display: flex;

    align-items: center;

    justify-content: center;

    border-radius: 999px;

    background:

            rgba(0,153,255,0.12);

    border:

            1px solid
            rgba(0,153,255,0.3);

    color: #46b7ff;

    font-size: 14px;

    font-weight: 700;
}





/* =========================
   관리 버튼
========================= */

.post-action-cell {

    display: flex;

    align-items: center;

    gap: 10px;

    justify-content: flex-start;

    flex-wrap: wrap;
}





.action-button {

    min-width: 64px;

    height: 40px;

    padding: 0 16px;

    border: none;

    border-radius: 999px;

    color: white;

    font-size: 13px;

    font-weight: 700;

    cursor: pointer;

    transition: 0.2s;
}





.action-button:hover {

    transform: translateY(-2px);
}





/* 댓글 버튼 */
.action-button.comment {

    background:

            linear-gradient(
                    135deg,
                    #1f8fff,
                    #2563eb
            );
}





/* 수정 버튼 */
.action-button.edit {

    background:

            linear-gradient(
                    135deg,
                    #7c3aed,
                    #8b5cf6
            );
}





/* 삭제 버튼 */
.action-button.delete {

    background:

            linear-gradient(
                    135deg,
                    #ff4d4d,
                    #ff2f2f
            );
}





/* =========================
   페이지네이션
========================= */

.pagination-wrap {

    display: flex;

    justify-content: center;

    align-items: center;

    gap: 12px;

    margin-top: 34px;

    flex-wrap: wrap;
}





.page-button {

    min-width: 46px;

    height: 46px;

    border-radius: 16px;

    border:

            1px solid
            rgba(255,255,255,0.06);

    background:

            rgba(255,255,255,0.04);

    color:

            rgba(255,255,255,0.7);

    font-size: 14px;

    font-weight: 700;

    cursor: pointer;

    transition: 0.25s;
}





.page-button:hover {

    transform: translateY(-2px);

    border-color:

            rgba(122,92,255,0.4);
}





.page-button.active {

    background:

            linear-gradient(
                    135deg,
                    #7c3aed,
                    #60a5fa
            );

    color: white;

    border-color: transparent;

    box-shadow:

            0 10px 24px
            rgba(124,58,237,0.24);
}





/* =========================
   수정 모달
========================= */

.edit-modal-overlay {

    position: fixed;

    inset: 0;

    z-index: 9999;

    display: flex;

    align-items: center;

    justify-content: center;

    background:
            rgba(0,0,0,0.6);

    backdrop-filter: blur(6px);
}





.edit-modal {

    width: 92%;

    max-width: 620px;

    padding: 28px;

    border-radius: 28px;

    background:

            linear-gradient(
                    135deg,
                    rgba(18,18,18,0.96),
                    rgba(28,28,28,0.96)
            );

    border:

            1px solid
            rgba(255,255,255,0.08);

    box-shadow:

            0 20px 60px
            rgba(0,0,0,0.45);
}





.edit-modal-title {

    color: white;

    font-size: 22px;

    font-weight: 800;

    margin-bottom: 22px;
}





.edit-textarea {

    width: 100%;

    min-height: 220px;

    resize: none;

    border: none;

    outline: none;

    border-radius: 18px;

    padding: 18px;

    background:
            rgba(255,255,255,0.05);

    color: white;

    font-size: 15px;

    line-height: 1.7;
}





.edit-textarea::placeholder {

    color:
            rgba(255,255,255,0.35);
}





.edit-modal-buttons {

    display: flex;

    justify-content: flex-end;

    gap: 12px;

    margin-top: 22px;
}





.modal-button {

    min-width: 92px;

    height: 42px;

    border: none;

    border-radius: 999px;

    color: white;

    font-size: 14px;

    font-weight: 700;

    cursor: pointer;

    transition: 0.25s;
}





.modal-button:hover {

    transform: translateY(-2px);
}





.modal-button.cancel {

    background:
            rgba(255,255,255,0.08);
}





.modal-button.save {

    background:

            linear-gradient(
                    135deg,
                    #7c3aed,
                    #60a5fa
            );
}





/* =========================
   Tablet
========================= */

@media (max-width: 1024px) {

    .post-table-header {

        grid-template-columns:
                60px
                1fr
                90px
                220px;

        padding: 16px;
    }





    .post-table-row {

        grid-template-columns:
                60px
                1fr
                90px
                220px;

        padding: 18px;

        min-height: 100px;
    }





    .post-content-cell {

        font-size: 16px;

        line-height: 1.6;
    }





    .action-button {

        min-width: 56px;

        height: 36px;

        font-size: 12px;
    }
}





/* =========================
   Mobile
========================= */

@media (max-width: 768px) {

    .post-search-input {

        width: 100%;
    }





    .post-table-header {

        display: none;
    }





    .post-table-row {

        display: flex;

        flex-direction: column;

        align-items: flex-start;

        gap: 18px;

        padding: 22px;

        border-radius: 22px;
    }





    .post-table-row > div:first-child {

        font-size: 22px;
    }





    .post-content-cell {

        width: 100%;

        font-size: 16px;

        line-height: 1.7;

        padding-right: 0;
    }





    .post-comment-count {

        width: 64px;

        height: 36px;

        font-size: 13px;
    }





    .post-action-cell {

        width: 100%;

        display: flex;

        justify-content: flex-start;

        flex-wrap: wrap;

        gap: 10px;
    }





    .action-button {

        flex: 1 1;

        min-width: 90px;

        height: 40px;

        font-size: 13px;
    }





    .pagination-wrap {

        gap: 8px;
    }





    .page-button {

        min-width: 40px;

        height: 40px;

        border-radius: 12px;

        font-size: 13px;
    }





    .edit-modal {

        width: 94%;

        padding: 22px;

        border-radius: 22px;
    }





    .edit-modal-title {

        font-size: 20px;
    }





    .edit-textarea {

        min-height: 180px;

        font-size: 14px;
    }





    .edit-modal-buttons {

        flex-direction: column;
    }





    .modal-button {

        width: 100%;
    }
}





/* =========================
   Small Mobile
========================= */

@media (max-width: 480px) {

    .post-table-row {

        padding: 18px;
    }





    .post-content-cell {

        font-size: 15px;

        line-height: 1.6;
    }





    .action-button {

        min-width: 72px;

        height: 36px;

        font-size: 12px;
    }





    .page-button {

        min-width: 36px;

        height: 36px;

        font-size: 12px;
    }





    .edit-modal {

        padding: 18px;
    }





    .edit-textarea {

        min-height: 160px;

        padding: 14px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/PostManage.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;AACf;;;;;;AAMA;;2BAE2B;;AAE3B;;IAEI,mBAAmB;AACvB;;;;;;AAMA;;IAEI,YAAY;;IAEZ,YAAY;;IAEZ,eAAe;;IAEf,mBAAmB;;IAEnB,wCAAwC;;IAExC;kCAC8B;;IAE9B,YAAY;;IAEZ,eAAe;;IAEf,aAAa;AACjB;;;;;;AAMA;;IAEI;kCAC8B;AAClC;;;;;;AAMA;;2BAE2B;;AAE3B;;IAEI,aAAa;;IAEb,sBAAsB;;IAEtB,SAAS;AACb;;;;;;AAMA;;2BAE2B;;AAE3B;;IAEI,aAAa;;IAEb;;;;iBAIa;;IAEb,mBAAmB;;IAEnB,kBAAkB;;IAElB,mBAAmB;;IAEnB;;;;;;;;;aASS;;IAET;;;kCAG8B;;IAE9B;;iCAE6B;;IAE7B,eAAe;;IAEf,gBAAgB;AACpB;;;;;;AAMA;;2BAE2B;;AAE3B;;IAEI,aAAa;;IAEb;;;;iBAIa;;IAEb,mBAAmB;;IAEnB,SAAS;;IAET,iBAAiB;;IAEjB,aAAa;;IAEb,mBAAmB;;IAEnB;;;;;;;;;aASS;;IAET;;;kCAG8B;;IAE9B,iBAAiB;AACrB;;;;;;AAMA;;IAEI,2BAA2B;;IAE3B;;iCAE6B;AACjC;;;;;;AAMA;;2BAE2B;;AAE3B;;IAEI,eAAe;;IAEf,gBAAgB;;IAEhB,YAAY;AAChB;;;;;;AAMA;;2BAE2B;;AAE3B;;IAEI,WAAW;;IAEX,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;;IAEhB,gBAAgB;;IAEhB,sBAAsB;;IAEtB,mBAAmB;AACvB;;;;;;AAMA;;2BAE2B;;AAE3B;;IAEI,WAAW;;IAEX,YAAY;;IAEZ,aAAa;;IAEb,mBAAmB;;IAEnB,uBAAuB;;IAEvB,oBAAoB;;IAEpB;;gCAE4B;;IAE5B;;;+BAG2B;;IAE3B,cAAc;;IAEd,eAAe;;IAEf,gBAAgB;AACpB;;;;;;AAMA;;2BAE2B;;AAE3B;;IAEI,aAAa;;IAEb,mBAAmB;;IAEnB,SAAS;;IAET,2BAA2B;;IAE3B,eAAe;AACnB;;;;;;AAMA;;IAEI,eAAe;;IAEf,YAAY;;IAEZ,eAAe;;IAEf,YAAY;;IAEZ,oBAAoB;;IAEpB,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;;IAEhB,eAAe;;IAEf,gBAAgB;AACpB;;;;;;AAMA;;IAEI,2BAA2B;AAC/B;;;;;;AAMA,UAAU;AACV;;IAEI;;;;;;aAMS;AACb;;;;;;AAMA,UAAU;AACV;;IAEI;;;;;;aAMS;AACb;;;;;;AAMA,UAAU;AACV;;IAEI;;;;;;aAMS;AACb;;;;;;AAMA;;2BAE2B;;AAE3B;;IAEI,aAAa;;IAEb,uBAAuB;;IAEvB,mBAAmB;;IAEnB,SAAS;;IAET,gBAAgB;;IAEhB,eAAe;AACnB;;;;;;AAMA;;IAEI,eAAe;;IAEf,YAAY;;IAEZ,mBAAmB;;IAEnB;;;kCAG8B;;IAE9B;;kCAE8B;;IAE9B;;iCAE6B;;IAE7B,eAAe;;IAEf,gBAAgB;;IAEhB,eAAe;;IAEf,iBAAiB;AACrB;;;;;;AAMA;;IAEI,2BAA2B;;IAE3B;;gCAE4B;AAChC;;;;;;AAMA;;IAEI;;;;;;aAMS;;IAET,YAAY;;IAEZ,yBAAyB;;IAEzB;;;iCAG6B;AACjC;;;;;;AAMA;;2BAE2B;;AAE3B;;IAEI,eAAe;;IAEf,QAAQ;;IAER,aAAa;;IAEb,aAAa;;IAEb,mBAAmB;;IAEnB,uBAAuB;;IAEvB;2BACuB;;IAEvB,0BAA0B;AAC9B;;;;;;AAMA;;IAEI,UAAU;;IAEV,gBAAgB;;IAEhB,aAAa;;IAEb,mBAAmB;;IAEnB;;;;;;aAMS;;IAET;;;kCAG8B;;IAE9B;;;4BAGwB;AAC5B;;;;;;AAMA;;IAEI,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;;IAEhB,mBAAmB;AACvB;;;;;;AAMA;;IAEI,WAAW;;IAEX,iBAAiB;;IAEjB,YAAY;;IAEZ,YAAY;;IAEZ,aAAa;;IAEb,mBAAmB;;IAEnB,aAAa;;IAEb;kCAC8B;;IAE9B,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;AACpB;;;;;;AAMA;;IAEI;kCAC8B;AAClC;;;;;;AAMA;;IAEI,aAAa;;IAEb,yBAAyB;;IAEzB,SAAS;;IAET,gBAAgB;AACpB;;;;;;AAMA;;IAEI,eAAe;;IAEf,YAAY;;IAEZ,YAAY;;IAEZ,oBAAoB;;IAEpB,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;;IAEhB,eAAe;;IAEf,iBAAiB;AACrB;;;;;;AAMA;;IAEI,2BAA2B;AAC/B;;;;;;AAMA;;IAEI;kCAC8B;AAClC;;;;;;AAMA;;IAEI;;;;;;aAMS;AACb;;;;;;AAMA;;2BAE2B;;AAE3B;;IAEI;;QAEI;;;;qBAIa;;QAEb,aAAa;IACjB;;;;;;IAMA;;QAEI;;;;qBAIa;;QAEb,aAAa;;QAEb,iBAAiB;IACrB;;;;;;IAMA;;QAEI,eAAe;;QAEf,gBAAgB;IACpB;;;;;;IAMA;;QAEI,eAAe;;QAEf,YAAY;;QAEZ,eAAe;IACnB;AACJ;;;;;;AAMA;;2BAE2B;;AAE3B;;IAEI;;QAEI,WAAW;IACf;;;;;;IAMA;;QAEI,aAAa;IACjB;;;;;;IAMA;;QAEI,aAAa;;QAEb,sBAAsB;;QAEtB,uBAAuB;;QAEvB,SAAS;;QAET,aAAa;;QAEb,mBAAmB;IACvB;;;;;;IAMA;;QAEI,eAAe;IACnB;;;;;;IAMA;;QAEI,WAAW;;QAEX,eAAe;;QAEf,gBAAgB;;QAEhB,gBAAgB;IACpB;;;;;;IAMA;;QAEI,WAAW;;QAEX,YAAY;;QAEZ,eAAe;IACnB;;;;;;IAMA;;QAEI,WAAW;;QAEX,aAAa;;QAEb,2BAA2B;;QAE3B,eAAe;;QAEf,SAAS;IACb;;;;;;IAMA;;QAEI,SAAO;;QAEP,eAAe;;QAEf,YAAY;;QAEZ,eAAe;IACnB;;;;;;IAMA;;QAEI,QAAQ;IACZ;;;;;;IAMA;;QAEI,eAAe;;QAEf,YAAY;;QAEZ,mBAAmB;;QAEnB,eAAe;IACnB;;;;;;IAMA;;QAEI,UAAU;;QAEV,aAAa;;QAEb,mBAAmB;IACvB;;;;;;IAMA;;QAEI,eAAe;IACnB;;;;;;IAMA;;QAEI,iBAAiB;;QAEjB,eAAe;IACnB;;;;;;IAMA;;QAEI,sBAAsB;IAC1B;;;;;;IAMA;;QAEI,WAAW;IACf;AACJ;;;;;;AAMA;;2BAE2B;;AAE3B;;IAEI;;QAEI,aAAa;IACjB;;;;;;IAMA;;QAEI,eAAe;;QAEf,gBAAgB;IACpB;;;;;;IAMA;;QAEI,eAAe;;QAEf,YAAY;;QAEZ,eAAe;IACnB;;;;;;IAMA;;QAEI,eAAe;;QAEf,YAAY;;QAEZ,eAAe;IACnB;;;;;;IAMA;;QAEI,aAAa;IACjB;;;;;;IAMA;;QAEI,iBAAiB;;QAEjB,aAAa;IACjB;AACJ","sourcesContent":[".post-manage {\n\n    width: 100%;\n}\n\n\n\n\n\n/* =========================\n   검색\n========================= */\n\n.post-search-wrap {\n\n    margin-bottom: 20px;\n}\n\n\n\n\n\n.post-search-input {\n\n    width: 320px;\n\n    height: 44px;\n\n    padding: 0 18px;\n\n    border-radius: 14px;\n\n    border: 1px solid rgba(255,255,255,0.08);\n\n    background:\n            rgba(255,255,255,0.04);\n\n    color: white;\n\n    font-size: 14px;\n\n    outline: none;\n}\n\n\n\n\n\n.post-search-input::placeholder {\n\n    color:\n            rgba(255,255,255,0.35);\n}\n\n\n\n\n\n/* =========================\n   테이블\n========================= */\n\n.post-table {\n\n    display: flex;\n\n    flex-direction: column;\n\n    gap: 14px;\n}\n\n\n\n\n\n/* =========================\n   헤더\n========================= */\n\n.post-table-header {\n\n    display: grid;\n\n    grid-template-columns:\n            80px\n            1fr\n            110px\n            250px;\n\n    align-items: center;\n\n    padding: 18px 22px;\n\n    border-radius: 22px;\n\n    background:\n\n            linear-gradient(\n\n                    135deg,\n\n                    rgba(255,255,255,0.05),\n\n                    rgba(255,255,255,0.02)\n            );\n\n    border:\n\n            1px solid\n            rgba(255,255,255,0.06);\n\n    color:\n\n            rgba(255,255,255,0.7);\n\n    font-size: 14px;\n\n    font-weight: 700;\n}\n\n\n\n\n\n/* =========================\n   카드\n========================= */\n\n.post-table-row {\n\n    display: grid;\n\n    grid-template-columns:\n            80px\n            1fr\n            110px\n            250px;\n\n    align-items: center;\n\n    gap: 12px;\n\n    min-height: 120px;\n\n    padding: 24px;\n\n    border-radius: 26px;\n\n    background:\n\n            linear-gradient(\n\n                    135deg,\n\n                    rgba(255,255,255,0.05),\n\n                    rgba(0,153,255,0.06)\n            );\n\n    border:\n\n            1px solid\n            rgba(255,255,255,0.05);\n\n    transition: 0.25s;\n}\n\n\n\n\n\n.post-table-row:hover {\n\n    transform: translateY(-2px);\n\n    border-color:\n\n            rgba(122,92,255,0.35);\n}\n\n\n\n\n\n/* =========================\n   번호\n========================= */\n\n.post-table-row > div:first-child {\n\n    font-size: 28px;\n\n    font-weight: 800;\n\n    color: white;\n}\n\n\n\n\n\n/* =========================\n   내용\n========================= */\n\n.post-content-cell {\n\n    width: 100%;\n\n    color: white;\n\n    font-size: 18px;\n\n    font-weight: 600;\n\n    line-height: 1.8;\n\n    word-break: break-word;\n\n    padding-right: 20px;\n}\n\n\n\n\n\n/* =========================\n   댓글 카운트\n========================= */\n\n.post-comment-count {\n\n    width: 70px;\n\n    height: 42px;\n\n    display: flex;\n\n    align-items: center;\n\n    justify-content: center;\n\n    border-radius: 999px;\n\n    background:\n\n            rgba(0,153,255,0.12);\n\n    border:\n\n            1px solid\n            rgba(0,153,255,0.3);\n\n    color: #46b7ff;\n\n    font-size: 14px;\n\n    font-weight: 700;\n}\n\n\n\n\n\n/* =========================\n   관리 버튼\n========================= */\n\n.post-action-cell {\n\n    display: flex;\n\n    align-items: center;\n\n    gap: 10px;\n\n    justify-content: flex-start;\n\n    flex-wrap: wrap;\n}\n\n\n\n\n\n.action-button {\n\n    min-width: 64px;\n\n    height: 40px;\n\n    padding: 0 16px;\n\n    border: none;\n\n    border-radius: 999px;\n\n    color: white;\n\n    font-size: 13px;\n\n    font-weight: 700;\n\n    cursor: pointer;\n\n    transition: 0.2s;\n}\n\n\n\n\n\n.action-button:hover {\n\n    transform: translateY(-2px);\n}\n\n\n\n\n\n/* 댓글 버튼 */\n.action-button.comment {\n\n    background:\n\n            linear-gradient(\n                    135deg,\n                    #1f8fff,\n                    #2563eb\n            );\n}\n\n\n\n\n\n/* 수정 버튼 */\n.action-button.edit {\n\n    background:\n\n            linear-gradient(\n                    135deg,\n                    #7c3aed,\n                    #8b5cf6\n            );\n}\n\n\n\n\n\n/* 삭제 버튼 */\n.action-button.delete {\n\n    background:\n\n            linear-gradient(\n                    135deg,\n                    #ff4d4d,\n                    #ff2f2f\n            );\n}\n\n\n\n\n\n/* =========================\n   페이지네이션\n========================= */\n\n.pagination-wrap {\n\n    display: flex;\n\n    justify-content: center;\n\n    align-items: center;\n\n    gap: 12px;\n\n    margin-top: 34px;\n\n    flex-wrap: wrap;\n}\n\n\n\n\n\n.page-button {\n\n    min-width: 46px;\n\n    height: 46px;\n\n    border-radius: 16px;\n\n    border:\n\n            1px solid\n            rgba(255,255,255,0.06);\n\n    background:\n\n            rgba(255,255,255,0.04);\n\n    color:\n\n            rgba(255,255,255,0.7);\n\n    font-size: 14px;\n\n    font-weight: 700;\n\n    cursor: pointer;\n\n    transition: 0.25s;\n}\n\n\n\n\n\n.page-button:hover {\n\n    transform: translateY(-2px);\n\n    border-color:\n\n            rgba(122,92,255,0.4);\n}\n\n\n\n\n\n.page-button.active {\n\n    background:\n\n            linear-gradient(\n                    135deg,\n                    #7c3aed,\n                    #60a5fa\n            );\n\n    color: white;\n\n    border-color: transparent;\n\n    box-shadow:\n\n            0 10px 24px\n            rgba(124,58,237,0.24);\n}\n\n\n\n\n\n/* =========================\n   수정 모달\n========================= */\n\n.edit-modal-overlay {\n\n    position: fixed;\n\n    inset: 0;\n\n    z-index: 9999;\n\n    display: flex;\n\n    align-items: center;\n\n    justify-content: center;\n\n    background:\n            rgba(0,0,0,0.6);\n\n    backdrop-filter: blur(6px);\n}\n\n\n\n\n\n.edit-modal {\n\n    width: 92%;\n\n    max-width: 620px;\n\n    padding: 28px;\n\n    border-radius: 28px;\n\n    background:\n\n            linear-gradient(\n                    135deg,\n                    rgba(18,18,18,0.96),\n                    rgba(28,28,28,0.96)\n            );\n\n    border:\n\n            1px solid\n            rgba(255,255,255,0.08);\n\n    box-shadow:\n\n            0 20px 60px\n            rgba(0,0,0,0.45);\n}\n\n\n\n\n\n.edit-modal-title {\n\n    color: white;\n\n    font-size: 22px;\n\n    font-weight: 800;\n\n    margin-bottom: 22px;\n}\n\n\n\n\n\n.edit-textarea {\n\n    width: 100%;\n\n    min-height: 220px;\n\n    resize: none;\n\n    border: none;\n\n    outline: none;\n\n    border-radius: 18px;\n\n    padding: 18px;\n\n    background:\n            rgba(255,255,255,0.05);\n\n    color: white;\n\n    font-size: 15px;\n\n    line-height: 1.7;\n}\n\n\n\n\n\n.edit-textarea::placeholder {\n\n    color:\n            rgba(255,255,255,0.35);\n}\n\n\n\n\n\n.edit-modal-buttons {\n\n    display: flex;\n\n    justify-content: flex-end;\n\n    gap: 12px;\n\n    margin-top: 22px;\n}\n\n\n\n\n\n.modal-button {\n\n    min-width: 92px;\n\n    height: 42px;\n\n    border: none;\n\n    border-radius: 999px;\n\n    color: white;\n\n    font-size: 14px;\n\n    font-weight: 700;\n\n    cursor: pointer;\n\n    transition: 0.25s;\n}\n\n\n\n\n\n.modal-button:hover {\n\n    transform: translateY(-2px);\n}\n\n\n\n\n\n.modal-button.cancel {\n\n    background:\n            rgba(255,255,255,0.08);\n}\n\n\n\n\n\n.modal-button.save {\n\n    background:\n\n            linear-gradient(\n                    135deg,\n                    #7c3aed,\n                    #60a5fa\n            );\n}\n\n\n\n\n\n/* =========================\n   Tablet\n========================= */\n\n@media (max-width: 1024px) {\n\n    .post-table-header {\n\n        grid-template-columns:\n                60px\n                1fr\n                90px\n                220px;\n\n        padding: 16px;\n    }\n\n\n\n\n\n    .post-table-row {\n\n        grid-template-columns:\n                60px\n                1fr\n                90px\n                220px;\n\n        padding: 18px;\n\n        min-height: 100px;\n    }\n\n\n\n\n\n    .post-content-cell {\n\n        font-size: 16px;\n\n        line-height: 1.6;\n    }\n\n\n\n\n\n    .action-button {\n\n        min-width: 56px;\n\n        height: 36px;\n\n        font-size: 12px;\n    }\n}\n\n\n\n\n\n/* =========================\n   Mobile\n========================= */\n\n@media (max-width: 768px) {\n\n    .post-search-input {\n\n        width: 100%;\n    }\n\n\n\n\n\n    .post-table-header {\n\n        display: none;\n    }\n\n\n\n\n\n    .post-table-row {\n\n        display: flex;\n\n        flex-direction: column;\n\n        align-items: flex-start;\n\n        gap: 18px;\n\n        padding: 22px;\n\n        border-radius: 22px;\n    }\n\n\n\n\n\n    .post-table-row > div:first-child {\n\n        font-size: 22px;\n    }\n\n\n\n\n\n    .post-content-cell {\n\n        width: 100%;\n\n        font-size: 16px;\n\n        line-height: 1.7;\n\n        padding-right: 0;\n    }\n\n\n\n\n\n    .post-comment-count {\n\n        width: 64px;\n\n        height: 36px;\n\n        font-size: 13px;\n    }\n\n\n\n\n\n    .post-action-cell {\n\n        width: 100%;\n\n        display: flex;\n\n        justify-content: flex-start;\n\n        flex-wrap: wrap;\n\n        gap: 10px;\n    }\n\n\n\n\n\n    .action-button {\n\n        flex: 1;\n\n        min-width: 90px;\n\n        height: 40px;\n\n        font-size: 13px;\n    }\n\n\n\n\n\n    .pagination-wrap {\n\n        gap: 8px;\n    }\n\n\n\n\n\n    .page-button {\n\n        min-width: 40px;\n\n        height: 40px;\n\n        border-radius: 12px;\n\n        font-size: 13px;\n    }\n\n\n\n\n\n    .edit-modal {\n\n        width: 94%;\n\n        padding: 22px;\n\n        border-radius: 22px;\n    }\n\n\n\n\n\n    .edit-modal-title {\n\n        font-size: 20px;\n    }\n\n\n\n\n\n    .edit-textarea {\n\n        min-height: 180px;\n\n        font-size: 14px;\n    }\n\n\n\n\n\n    .edit-modal-buttons {\n\n        flex-direction: column;\n    }\n\n\n\n\n\n    .modal-button {\n\n        width: 100%;\n    }\n}\n\n\n\n\n\n/* =========================\n   Small Mobile\n========================= */\n\n@media (max-width: 480px) {\n\n    .post-table-row {\n\n        padding: 18px;\n    }\n\n\n\n\n\n    .post-content-cell {\n\n        font-size: 15px;\n\n        line-height: 1.6;\n    }\n\n\n\n\n\n    .action-button {\n\n        min-width: 72px;\n\n        height: 36px;\n\n        font-size: 12px;\n    }\n\n\n\n\n\n    .page-button {\n\n        min-width: 36px;\n\n        height: 36px;\n\n        font-size: 12px;\n    }\n\n\n\n\n\n    .edit-modal {\n\n        padding: 18px;\n    }\n\n\n\n\n\n    .edit-textarea {\n\n        min-height: 160px;\n\n        padding: 14px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
